(function($) {

/**
 * define responsive nav component as its own jQuery extension
 */
$.fn.responsiveNav = function( options ) {


	options = $.extend({}, {
		wrapperSelector: '.site-wrapper',
		menuButtonSelector: '.menu-btn',
		menuOpenClass: 'menu-open',
		menuButtonActiveClass: 'active',
	}, options);

	var $this = $(this),
		menuOpen = false,
		$wrapper = $( options.wrapperSelector ),
		$menuButton = $( options.menuButtonSelector );

	var closeNav = function() {
		$wrapper.removeClass( options.menuOpenClass );
		$menuButton.removeClass( options.menuButtonActiveClass );

		//remove any inline styles from subnavigation
		//$this.find( 'ul' ).removeAttr( 'style' );

		menuOpen = false;
	};

	var bodyClickFn = function(evt) {
		//if not nav container or a decendant of nav container
		if( !$this.is(evt.target) && $this.has(evt.target).length === 0 ) {
			closeNav();
			$('.site-wrapper').unbind( 'touchstart, click', bodyClickFn );
		}
	};

	var menuBtnFn = function() {

		$menuButton.bind( 'touchstart, click', function(event) {

			event.stopPropagation();
			event.preventDefault();

			if ( menuOpen ) {
				closeNav();
			}
			else{
				$wrapper.addClass( options.menuOpenClass );
				$(this).addClass( options.menuButtonActiveClass );

				menuOpen = true;
				$('.site-wrapper').bind( 'touchstart, click', bodyClickFn );
			}
		}); //end button bind
	}; //end menuBtnFn

	var mobileSubNav = function() {
		$('.mobile-sub-nav > div.has-dropdown-items > .dropper').each(function(){
			$(this).bind('touchstart, click', function(event) {

				//	if toggled
				if($(this).closest('div.has-dropdown-items').hasClass('toggle')) {

					//	remove toggle status
					$(this).closest('div.has-dropdown-items').removeClass('toggle');

					//	slide menu items up
					$(this).closest('div.has-dropdown-items').next('.item-container').slideUp(250);

				} else {

					//	add toggle status
					$(this).closest('div.has-dropdown-items').addClass('toggle');

					//	slide menu items up
					$(this).closest('div.has-dropdown-items').next('.item-container').slideDown(250);
				}
			}); //end bind
		});
	};

	var secondlevelNav = function() {
		$this.find('ul.main-nav__menu > li.menu-item-has-children > .dropper').each(function(){
			$(this).bind('touchstart, click', function(event) {

				// On mobile, don't allow clicks on root level nav items
				if( $menuButton.is(':visible') ){
					event.stopPropagation();
					event.preventDefault();
				}
				
				if ( menuOpen && !$(this).next().is(':visible') && $(this).next().length > 0) {

					//close what's already open
					$this.find('ul.main-nav__menu li').removeClass('toggle');
					$this.find('ul.main-nav__menu > li ul').slideUp(250);

					//expand current click
					$(this).parent().addClass('toggle');
					$(this).next('ul').slideDown(250);

				}
				else if ( menuOpen && $(this).next('ul').is(':visible') ) {
					//close this item
					$(this).parent().removeClass('toggle');
					$(this).next('ul').slideUp(250);
				}

			}); //end bind
		});
	};//end secondlevelNav

	var thirdlevelNav = function() {
		$this.find('ul.main-nav__menu > li.menu-item-has-children > ul > li.menu-item-has-children > .dropper').each(function(){
			$(this).bind('touchstart, click', function(event) {

				// On mobile, don't allow clicks on root level nav items
				if( $menuButton.is(':visible') ){
					event.stopPropagation();
					event.preventDefault();
				}

				if ( menuOpen && !$(this).next().is(':visible') && $(this).next().length > 0) {

					//close what's already open
					$this.find('ul.main-nav__menu > li ul > li').removeClass('toggle');
					$this.find('ul.main-nav__menu > li ul > li ul').slideUp(250);

					//expand current click
					$(this).parent().addClass('toggle');
					$(this).next('ul').slideDown(250);

				}
				else if ( menuOpen && $(this).next('ul').is(':visible') ) {
					//close this item
					$(this).parent().removeClass('toggle');
					$(this).next('ul').slideUp(250);
				}

			}); //end bind
		});

	};//end fn thirdlevelNav

	var activeToggleFn = function(){
		//on mobile check for active navigation and set open accordingly
		if( $menuButton.is(':visible') ){

			// TODO, see if we can detect special pages like Shop to expand the menu when active.
			
			$this.find(
				'ul.main-nav__menu li.current_page_item, ' +
				'ul.main-nav__menu li.current_page_ancestor'
			).each(function(){
					if( !$(this).hasClass('toggle') ){
						$(this).addClass('toggle');
					}
					if( !$(this).children('ul').is(':visible') ){
						$(this).children('ul').show();
					}
			});
		}
	}; //end activeToggleFn

	menuBtnFn();
	secondlevelNav();
	thirdlevelNav();
	activeToggleFn();
	mobileSubNav();

	$(window).resize(function(){
		if( !$menuButton.is(':visible') ) {
			closeNav();
			$this.find('ul.main-nav__menu ul').removeAttr('style');
		}
		else{
			activeToggleFn();
		}
	});

	return this;
};
})(jQuery);
